export default __webpack_public_path__ + "static/media/creatives-placeholder.8906455d.svg";